type WithBusinessSector = {
  businessSectorId?: string | null;
  businessSectorRelation?: { parentId: string | null } | null;
};

export const matchesBusinessSectorFilter = <T extends WithBusinessSector>(
  item: T,
  selectedBusinessSectorIds: string[],
): boolean => {
  if (selectedBusinessSectorIds.length === 0) return true;
  if (!item.businessSectorId) return false;

  const directMatch = selectedBusinessSectorIds.includes(item.businessSectorId);
  const parentMatch = item.businessSectorRelation?.parentId
    ? selectedBusinessSectorIds.includes(item.businessSectorRelation.parentId)
    : false;

  return directMatch || parentMatch;
};
